

export function createExampleOptions (setting) {
  return `
    <h5>Example</h5>
    <ul class="example-config">
    <li>{</li>
    <li id="position">position: <span>'${setting.position}'</span>,</li>
    <li id="arrowPosition">arrowPosition: <span>${setting.arrowPosition}</span>,</li>
    <li id="tooltipMove">tooltipMove: <span>${setting.tooltipMove}</span>,</li>
    <li id="cross">cross: <span>${setting.cross}</span>,</li>
    <li id="arrow">arrow: <span>${setting.arrow}</span>,</li>
    <li id="margin">margin: <span>${setting.margin}</span></li>
    <li>}</li>
    </ul>
  `

}
